import { useParams } from 'react-router-dom';
import List from './components/List';
import ViewUser from './components/View';

export default function Members() {
  const params = useParams();

  return params?.id ? <ViewUser /> : <List />;
}
